// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___2zUck","addText":"AddFilterBox__addText___RnVhx","addFilterContainer":"AddFilterBox__addFilterContainer___2B0si","addIcon":"AddFilterBox__addIcon___xIITR"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/projects/components/advancedSearch/AddFilterBox.scss
// module id = 1724
// module chunks = 0